import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import PopOver from '../../../Shared/Popover/Popover';
import {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setSupplyType,
  setTechnicianArrivalTime,
  setTechnicianArrivalTimeIbc,
  setFloor,
  setError,
  openPopover,
  closePopover,
} from '../saleBlockSlice';
import TechnicianArrivalTime from '../TechnicianArrivalTime/TechnicianArrivalTime';

const TechnicianPage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;

  const packageType = props.packageType; // none | open | closed
  const isBuildingConnectedFiber = props.selectedAddress.infrastructure?.tashtitType == 'FIBER' || props.selectedAddress.infrastructure?.tashtitType == 'IBC';
  const isBuildingConnectedIBC = props.selectedAddress.infrastructure?.tashtitType == 'IBC';
  const isBuildingFutureDate = props.selectedAddress.infrastructure?.assetMarketStatus == 'בניין לקראת חיבור';
  const isCustomerConnectedToIbc = props._isIBCInternetCustomer.isIBC == 'isIBC';
  const isBezeqFiber = props.selectedAddress.infrastructure?.tashtitType == 'BF';

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_10' : 'visibility_18',
          eventLabel: eventLabel,
        });
        break;
      case 'app':
        break;
      case 'cellular':
        break;
      case 'internet':
        let eventAction = '';
        switch (props.packageType) {
          case 'closed':
            eventAction = 'visibility_3';
            break;
          case 'none':
            eventAction = 'visibility_5';
            break;
          case 'open':
            eventAction = 'visibility_7';
            break;
        }
        if (isBuildingFutureDate) {
          eventAction = 'visibility_8';
        }
        if (isBuildingConnectedIBC) {
          eventAction =  (isCustomerConnectedToIbc ? 'visibility_10' : 'visibility_11');
        }       
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: eventAction, eventLabel: eventLabel});
        break;
    }
  }, []);

  const openPopOverHandle = () => {
    props.openPopover();
    props.reportAnalytics({
      eventCategory: 'fiber_newsale_process',
      eventAction: 'click_14',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
  };

  //page params
  let isDisplayFooter = true;
  let btnText = 'ממשיכים';
  let currentPageFunction = handleTechnicianPageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let title = 'מתי יגיע טכנאי?';
  let subTitle = null;
  let remark = null;
  btnText = 'ממשיכים';

  if (saleType == 'internet') {
    if (packageType == 'closed' && (isBuildingConnectedFiber || isBezeqFiber)) {
      title = 'מתי יגיע טכנאי?';
      subTitle = '';
      btnText = 'קבענו, אפשר להתקדם';
    }
    if (packageType == 'none') {
      title = 'מצוין, נשאר רק לתאם לכם טכנאי להתקנה';
      subTitle = '';
      btnText = 'קבענו, אפשר להתקדם';
    }
    if (packageType == 'open') {
      title = 'מתי יגיע טכנאי?';
      remark = 'אל דאגה, הטכנאי ללא עלות';
      subTitle = 'הטכנאי יגיע לכתובת שהזנת קודם';
    }
    if (isBuildingFutureDate) {
      title = 'ממש בקרוב הסיבים שלנו יגיעו אליכם';
      subTitle = 'בינתיים, כדאי כבר עכשיו להזמין חבילה ולתאם התקנה.';
      btnText = 'קבענו, אפשר להתקדם';
    }
  } else {
    title = 'מתי נוח לכם שנגיע?';
    remark = 'אל דאגה, הטכנאי ללא עלות';
    subTitle = props.configuration.isAllowDelivery && (
      <a href='javascript:void(0)' onClick={handleTechnicianPageBack}>
        {' '}
        רוצים להתקין בעצמכם ורק לתאם משלוח?{' '}
      </a>
    );
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-remark'>{remark}</h2>
      <h2 className='sale-title-small'>{subTitle}</h2>
    </div>
  );

  let currentPageView = (
    <TechnicianArrivalTime
      onError={handleOnError}
      selectedAddress={props.selectedAddress}
      onValid={handleTechnicianValidate}
      onSubmit={props.isSubmit}
      isBezeqFiber={isBezeqFiber}
    />
  );

  function handleTechnicianPageContinue() {
    props.setIsSubmit({isSubmit: true});
  }

  function handleTechnicianPageBack() {
    props.goToPage({page: 'deliveryAddressPage', percent: props.percent});

    const eventLabel = props.productsInfo.selectedProducts[0]?.name;
    props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: (flowType == 'existsCustomer' ? 'click_13' : 'click_25'), eventLabel: eventLabel});
  }

  function handleTechnicianValidate(valid) {
    props.setIsSubmit({isSubmit: false});
    if (valid) {
      handleTechnicianPageContinueAfterValid();
    }
    props.setIsSubmit({isSubmit: false});
  }

  function handleTechnicianPageContinueAfterValid() {
    const eventLabel = props.productsInfo.selectedProducts[0]?.name;

    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: (flowType == 'existsCustomer' ? 'click_14' : 'click_26'), eventLabel: eventLabel});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'click_26', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_1', eventLabel: eventLabel});
        break;
      case 'internet':
        let eventAction = '';
        switch (props.packageType) {
          case 'closed':
            eventAction = 'click_3';
            break;
          case 'none':
            eventAction = 'click_5';
            break;
          case 'open':
            eventAction = 'click_7';
            break;
        }
        if (isBuildingFutureDate) {
          eventAction = 'click_8';
        }
        if (isBuildingConnectedIBC) {
          eventAction = (isCustomerConnectedToIbc ? 'click_12' : 'click_15');
        }
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: eventAction, eventLabel: eventLabel});
        break;
    }

    props.setSupplyType({supplyType: 'technician'});

    const technicianArrivalTime = {
      arrivalTime: props._technicianArrivalTime.arrivalTime,
      arrivalStartDate: props._technicianArrivalTime.arrivalStartDate,
      arrivalEndDate: props._technicianArrivalTime.arrivalEndDate        
    };
    props.setTechnicianArrivalTime({technicianArrivalTime: technicianArrivalTime});

    if (saleType == 'internet' && isBezeqFiber) {
      props.setFloor({floor: props._technicianArrivalTime.floor});
    }

    switch (saleType) {
      case 'tv':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'emailPage', percent: 55});
        } else {
          props.goToPage({page: 'otpVerifyPhone', percent: 45});
        }
        break;
      case 'cellular':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'emailPage', percent: 70});
        } else {
          props.goToPage({page: 'otpVerifyPhone', percent: 50});
        }
        break;
      case 'internet':
        if (flowType == 'existsCustomer') {
          props.goToPage({page: 'userAddressPage', percent: 48});
        } else {
          props.goToPage({page: 'personalInfoPage', percent: 60});
        }
        break;
    }
  }

  function handleOnError(errorId) {

    if (errorId == 18 && props._setupDeliveriesError != 20 && saleType == 'tv') {
      if (props.configuration.isAllowDelivery) {
        props.goToPage({page: 'deliveryAddressPage', percent: props.percent});
      }
    } else {
      props.setError({isDisplay: true, id: errorId, isOpenWorkOrder: true});
    }
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    configuration: state.saleBlock.epiServer.configuration,
    selectedAddress: state.saleBlock.selectedAddress,
    isCustomerConnectedToIbc: state.saleBlock.isCustomerConnectedToIbc,
    togglePopover: state.saleBlock.togglePopover,
    packageType: state.saleBlock.packageType,
    isOtherAddress: state.saleBlock.isOtherAddress,
    isSkipToNewCustomer: state.saleBlock.isSkipToNewCustomer,
    productsInfo: state.saleBlock.productsInfo,

    //other states
    _technicianArrivalTime: state.technicianArrivalTime.form,
    _setupDeliveriesError: state.setupDeliveries.form.errorId,
    _isIBCInternetCustomer: state.IsIBCInternetCustomer
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setSupplyType,
  setTechnicianArrivalTime,
  setTechnicianArrivalTimeIbc,
  setFloor,
  setError,
  openPopover,
  closePopover,
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianPage);
